import {useMutation} from '@tanstack/react-query';
import {type} from 'arktype';
import {SessionExpiredError, useLogout, UserStatusArktype} from '~/entities/user';
import {expectOneOf, POST, useHttpClient} from '~/library/network-facade';

export function useKycStartMutation() {
    const url = 'v1/on_boarding/start';
    const http = useHttpClient();
    const logout = useLogout();
    return useMutation({
        mutationKey: [url],
        mutationFn: async () => {
            const {status, json} = await http(url, POST()).then(
                expectOneOf({
                    200: type({
                        status: UserStatusArktype,
                        token: 'string',
                    }),
                    400: type({
                        code: '2',
                        message: 'string',
                        status: UserStatusArktype,
                    }),
                    503: type({
                        code: '1',
                        message: 'string',
                    }),
                    401: null,
                })
            );

            switch (status) {
                case 200:
                    return {value: json};
                case 400:
                    return {problem: json};
                case 503:
                    return {problem: json};
                case 401:
                    logout();
                    throw new SessionExpiredError();
            }
        },
    });
}
